import { render } from "./pinglunList.vue?vue&type=template&id=1f6daf6a&scoped=true"
import script from "./pinglunList.vue?vue&type=script&lang=js"
export * from "./pinglunList.vue?vue&type=script&lang=js"

import "./pinglunList.vue?vue&type=style&index=0&id=1f6daf6a&lang=less&scoped=scoped"
import "./pinglunList.vue?vue&type=style&index=1&id=1f6daf6a&lang=less"

import exportComponent from "F:\\project\\zifeiluntang\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6daf6a"]])

export default __exports__